<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UfNFXL/tc-custom/9798886930184.jpg?1705688258970" alt="This image is the cover for the book The Chimera Prophecies and Other Short Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Chimera Prophecies and Other Short Stories
      </h1>
      <p class="bookDescription body article font2">
        <p>When Sarah receives dreams of an apocalyptic world, she is met by the Chimera god Lycia to help her fulfill her destiny. Sarah is approached by a secret organization that believes she is the girl from an ancient prophecy. It predicts that Sarah is the key to saving the world from a cult leader who plans to unleash the god of chaos and destruction on Earth. Struggling to deal with dreams and her teenage life, Sarah begins to doubt herself and her sanity. With guidance from Lycia and encouragement from her mother, Sarah gains the strength and confidence she needs in order to save the world from annihilation.</p><p>In “The Starlight Hour” a young thief named Leona is offered an opportunity to pursue her dreams of being an artist, she is faced with a tough decision. Should she leave behind her community or stay and find a new purpose in life. After an attempt to gain money to fund her new opportunity, Leona ends up escaping a car chase from the police. After reflecting on her actions, Leona finds a new dream and learns the value of the people that are important to her life.</p><p>Seven other short stories accompany “The Chimera Prophecies”. All center around the themes of self-discovery, personal purpose in life, and the emotional journey of what it means to be human.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ashlie K. Manger
      </h2>
      
      <p class="authorDescription body article"><p>Author Ashlie K. Manger was born and raised in Southern California. Ashlie has a bachelor&rsquo;s degree from the University of Phoenix and a master&rsquo;s degree from Southern New Hampshire University. After years of working in a warehouse, Ashlie decided to quit her job and pursue a writing career. As a fan of science fiction and fantasy, Ashlie decided to assemble a collection of short stories to publish as a book. Ashlie&rsquo;s favorite books are <em>The Great Gatsby</em>&nbsp;by F. Scott Fitzgerald and <em>The Hunger Games</em> by Suzanne Collins. Other favorite authors are Rick Riordan, John Steinbeck, and Shirley Jackson.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71fd7e9f